import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

interface Props {
  title: string
  amount: number
  tooltip: React.ReactNode
}

const StatsRow = ({ title, amount, tooltip }: Props) => {
  const border = {
    style: 'solid',
    width: 's1',
    color: 'grey400',
  } as const

  return (
    <Box
      flexDirection="row"
      justifyContent="spaceBetween"
      alignItems="center"
      width="full"
      paddingY="s24"
      paddingX="s16"
      border={{
        bottom: border,
        top: border,
      }}
    >
      <Text.Header3>{title}</Text.Header3>
      <Box flexDirection="row" gap="s8">
        <Text.Header1>{i18n.formatNumber(amount)}</Text.Header1>
        {tooltip}
      </Box>
    </Box>
  )
}

export default StatsRow
